import { render, staticRenderFns } from "./EmailProviderBinding.vue?vue&type=template&id=a43e8768&"
import script from "./EmailProviderBinding.vue?vue&type=script&lang=ts&"
export * from "./EmailProviderBinding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports